import moment from 'moment';

import {
  ROBLOX_GAME_RANK_CHART_DAYS,
  ROBLOX_GAME_RANK_CHART_GROUP_BY,
  ROBLOX_GAME_RANK_CHART_PAGE_SIZE,
} from '../constants';
import { buildRobloxGameRankFetchParams } from './buildRobloxGameRankFetchParams';

import type { IMainGenre } from '@intelligence/types/common';
import type { IRobloxResolvedDateRange } from '@intelligence/v3/utils/robloxFilterDate';
import type { IRobloxGameRankFilterValues } from '../types';

interface IBuildRobloxGameRankChartFetchParamsOptions {
  source: string;
  gameIds: string[];
  robloxGenreOptions?: IMainGenre[];
  /** 表格响应 req 回填的榜单日期，用于计算折线图区间 */
  resolvedDateRange?: IRobloxResolvedDateRange | null;
}

export const buildRobloxGameRankChartFetchParams = (
  filterValues: IRobloxGameRankFilterValues,
  options: IBuildRobloxGameRankChartFetchParamsOptions,
) => {
  const params = buildRobloxGameRankFetchParams(filterValues, {
    source: options.source,
    gameIds: options.gameIds,
    page: 1,
    pageSize: ROBLOX_GAME_RANK_CHART_PAGE_SIZE,
    robloxGenreOptions: options.robloxGenreOptions,
  });

  const endDate = options.resolvedDateRange?.endDate
    || params.end_date;

  if (!endDate) {
    return params;
  }

  params.group_by = [...ROBLOX_GAME_RANK_CHART_GROUP_BY];
  params.end_date = endDate;
  params.start_date = moment(endDate).subtract(ROBLOX_GAME_RANK_CHART_DAYS, 'days').format('YYYY-MM-DD');

  return params;
};
